export default __webpack_public_path__ + "static/media/359a872511e20bc8.7180b24e3ff763476c5b7a8a07c8dd6d.svg";